/**
 * @desc 更新会员个人认证
 */
import {
  AuditPersonEntity,
  AuditPersonForm
} from '@eastcoal/api/auth/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type UpdateAuditPersonParameter = AuditPersonForm

const method = 'PUT'
const url = '/auth/audit/person'

export const updateAuditPersonApi = (
  data?: UpdateAuditPersonParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<AuditPersonEntity>({
    method,
    url,
    data,
    ...config
  })
}

updateAuditPersonApi.method = method
updateAuditPersonApi.url = url
